import { useContext, useEffect, useRef } from 'react';

import { InsightsContentContext } from 'contextProviders/InsightsContentProvider';
import { AnswerSourceFilter } from 'services/streamInsightsQuery';

// Registers the report's "apply these filters to my drill-downs" callback so the
// globally-mounted Insights Chat can carry an agent-applied filter through to the
// on-screen report. The reverse of useRegisterInsightsView (which publishes the
// view OUT); this lets a command come back IN.
//
// Pass null to register nothing (popups, wallboards, headless renders) — the same
// guard the view/value publishers use.
//
// The apply callback closes over the report's live setDrillDowns and field
// metadata, both of which change identity freely; an applyRef lets the latest
// closure be invoked without re-registering on every render.
const useRegisterApplyReportFilters = ({
  entityId,
  apply,
}: {
  entityId: string | null;
  apply: (filters: AnswerSourceFilter[]) => void;
}): void => {
  const { registerApplyFilters } = useContext(InsightsContentContext);

  const applyRef = useRef(apply);
  applyRef.current = apply;

  useEffect(() => {
    if (!entityId) {
      return undefined;
    }
    return registerApplyFilters(entityId, (filters) =>
      applyRef.current(filters),
    );
  }, [entityId, registerApplyFilters]);
};

export default useRegisterApplyReportFilters;
